module.exports = __webpack_public_path__ + "490c6ed379b0f9018f5d140fc729bdee.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-420.jpg
// module id = 578
// module chunks = 0